module.exports = __webpack_public_path__ + "static/img/core4.665a5747.png";